import { Deserializable } from './../deserializable';

export class PropositionInterfaceType implements Deserializable {
  public PropositionId: number;
  public InterfaceTypeId: number;
  public IsBankOfIrelandProposition: boolean;

  deserialize(input: any): this {
    Object.assign(this, input);

    return this;
  }
}
